import React, { useEffect, useState } from 'react';
import { Modal } from 'reactstrap';
import { PREVIEW_DIFFERENCES } from './previewDifferences';
import '../../styles/css/PreviewHomeScreenButtons.css'; // Make sure to import your CSS file

const MODULE_BUTTON_TYPES = ['isLeagueScoresModule', 'isSeasonGamesModule', 'isScheduleModule', 'isStandingsModule', 'isPlayerLeadersModule', 'isRosterModule', 'isScoreboardModule', 'isSlider'];

const MODULE_LABELS = {
    isLeagueScoresModule: 'League Scores Module',
    isSeasonGamesModule: 'Season Games Module',
    isScheduleModule: 'Schedule Module',
    isStandingsModule: 'Standings Module',
    isPlayerLeadersModule: 'Player Leaders Module',
    isRosterModule: 'Roster Module',
    isScoreboardModule: 'Scoreboard',
    isSlider: 'Top Carousel'
};

const Preview = ({ imagePreviews, backgroundImage }) => {
    const [containerWidth, setContainerWidth] = useState(0);
    const [showDifferences, setShowDifferences] = useState(false);

    // Update container width dynamically
    useEffect(() => {
        const updateWidth = () => {
            const previewContainer = document.querySelector('.preview-container');
            if (previewContainer) {
                setContainerWidth(previewContainer.offsetWidth);
            }
        };

        window.addEventListener('resize', updateWidth);
        updateWidth(); // Initial width setting

        return () => window.removeEventListener('resize', updateWidth); // Cleanup on unmount
    }, []);

    const height = containerWidth - (containerWidth * 0.4); // Calculate height proportional to width

    const isModuleButtonType = (buttonType) => MODULE_BUTTON_TYPES.includes(buttonType);

    return (
        <>
        <div className="preview-container" style={{ backgroundImage: `url(${backgroundImage})`, flexDirection: 'row', flexWrap: 'wrap', display: 'flex' }}>
            {imagePreviews.length > 0 ? (
                imagePreviews.map((image, index) => {
                    const pct = 1 / (image.buttonSizeRatio || 1);
                    const isModule = isModuleButtonType(image.buttonType);
                    // The scoreboard is a short strip in the app (64 of ~390 points), not a card.
                    const placeholderHeight = image.buttonType === 'isScoreboardModule' ? Math.round(containerWidth * 0.17) : height;

                    return (
                        <React.Fragment key={index}>
                            {isModule ? (
                                <div
                                    className="slider-placeholder"
                                    style={{ width: '100%', height: `${placeholderHeight}px` }}
                                >
                                    <p>{MODULE_LABELS[image.buttonType] || image.header}</p>
                                </div>
                            ) : (
                                <div className="image-wrapper" style={{width: `${pct * 100}%`}}>
                                    <img
                                        src={image.image}
                                        alt={`Preview ${index + 1}`}
                                        className="preview-image"
                                    />
                                </div>
                            )}
                        </React.Fragment>
                    )
                })
            ) : (
                <p>No images uploaded</p>
            )}
        </div>

        {/* The preview cannot mirror the app — it has none of the data the app
            decides with. Saying so here is cheaper than someone concluding the
            app is broken. */}
        <div className="preview-caveat">
            <p>
                A guide to order and size. What fans actually see depends on the night&rsquo;s data.
            </p>
            <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={() => setShowDifferences(true)}
            >
                Why it can look different
            </button>
        </div>

        <Modal isOpen={showDifferences} toggle={() => setShowDifferences(false)} id="previewDifferencesModal">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Why the app can look different</h5>
                    <button
                        type="button"
                        className="admin-modal-close"
                        aria-label="Close"
                        onClick={() => setShowDifferences(false)}
                    >
                        &times;
                    </button>
                </div>
                <div className="modal-body">
                    <p className="admin-hint" style={{ marginBottom: 18 }}>
                        This preview draws every button you have set up, in order. The app decides what to
                        show when a fan opens it, using things this screen cannot know &mdash; tonight&rsquo;s
                        scores, whether a carousel has images, which app it is. These are the differences
                        worth knowing about.
                    </p>
                    <ul className="preview-difference-list">
                        {PREVIEW_DIFFERENCES.map((difference, i) => (
                            <li key={i}>
                                <p className="preview-difference-title">{difference.title}</p>
                                <p className="preview-difference-detail">{difference.detail}</p>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="admin-modal-actions">
                    <button type="button" className="btn btn-primary" onClick={() => setShowDifferences(false)}>
                        Got it
                    </button>
                </div>
            </div>
        </Modal>
        </>
    );
};

export default Preview;
